// extracted by mini-css-extract-plugin
module.exports = {"issueType":"styles_issueType__1ita-"};